module.exports = __webpack_public_path__ + "static/img/liantong.59a913d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newimg/liantong.png
// module id = Xukv
// module chunks = 0